<template>
  <section class="container clearfix">
    <div class="shadow-wrapper padding-m mb-m">
      <h1 class="mb-m section-title">密碼變更</h1>
      <PasswordForm
        ref="passwordForm"
        :model="model"
        change-password
      />
    </div>
    <div class="text-right">
      <Button
        class="btn-m"
        :style="{marginRight: '10px'}"
        @click="handleReset"
        v-text="'重新填寫'"
      />
      <Button
        class="btn-primary btn-m"
        :disabled="loading"
        @click="handleSubmit"
        v-text="'確認送出'"
      />
    </div>
  </section>
</template>

<script>
  import { Button } from 'iview';
  import { mapState } from 'vuex';
  import PasswordForm from '@/components/forms/PasswordForm';
  // model
  import { model } from '@/utils/asyncValidator/changePasswordForm';
  // constants
  import { UPDATE_PASSWORD_ACTION } from '@/store/modules/user/constants';

  export default {
    components: { PasswordForm, Button },
    inheritAttrs: false,
    data() {
      return {
        model
      };
    },
    computed: {
      ...mapState({
        loading: state => state.user.loading
      })
    },
    methods: {
      async handleSubmit() {
        const { passwordForm } = this.$refs;
        const payload = await passwordForm.getPayload();
        const result = await this.$store.dispatch(UPDATE_PASSWORD_ACTION, payload);
        if (result) return this.handleReset();
      },
      handleReset() {
        return this.$refs.passwordForm.handleReset();
      }
    }
  };
</script>
